import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { cloneArray } from 'src/app/app.component';
import { OnboardingManagerService } from 'src/app/modules/my-journey/components/onboarding-manager/services/onboarding-manager.service';
import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';
import { CvLocationComponent } from '../cv-location/cv-location/cv-location.component';
import { NotificationService } from '../../services/notification/notification.service';
import { storage_url } from '../../functions/shared-functions';

@Component({
  selector: 'app-tm-address',
  templateUrl: './tm-address.component.html',
  styleUrls: ['./tm-address.component.scss']
})
export class TmAddressComponent implements OnInit {


  @Input() form_control;
  @Input() label;
  @Input() callbackfn;
  @Input() copyAddresslabel;
  @Input() readonly;
  @Input() masters;
  @Input() field;
  @Input() dynamic_form_group;
  @Input() disabled;
  @Input() readOnly;
  @Input() all_form;
  @Input() sec_data;
  storage_url = storage_url;
  // address_fg = new FormGroup({
  //   addressLine1: new FormControl(null),
  //   addressLine2: new FormControl(null),
  //   cityId: new FormControl(null),
  //   stateId: new FormControl(null),
  //   countryId: new FormControl(null),
  //   postalCode: new FormControl(null),
  //   attachments: new FormControl(null),
  // })


  constructor(
    private api: OnboardingManagerService,
    private dialog: MatDialog,
    private notification: NotificationService,
    private profile_settings_srv: ProfileSettingsService,

  ) { }

  ngOnInit() {
    // if (this.form_control && this.form_control.value) {
    //   this.address_fg.patchValue(this.form_control.value)
    // }

    // this.form_control.valueChanges.subscribe(res => {
    //  console.log(res);
    // })
  }

  ngOnChanges(changes) {
    console.log(changes);
  }

  transformFn(controlName, transform) {
    if ((controlName).value) {
      if (transform == 1) {
        controlName.setValue((controlName.value).toUpperCase())
      }
      else if (transform == 2) {
        controlName.setValue((controlName.value).toLowerCase())
      }
    }
  }

  optionSelected(ev, expression, form_group, field_obj) {
    console.log(ev);
    if (ev && expression) {
      try {
        eval(expression);
      }
      catch (err) {

      }
    }

    if (field_obj.enable_virtual_scroll) {
      // if (!this.extended_fields_titles[field_obj.parent_key]) {
      //   this.extended_fields_titles[field_obj.parent_key] = {}
      // }
      // let out_obj = {};
      // out_obj[field_obj['masterTitleProperty']] = ev[field_obj.title_property || 'title']
      // Object.assign(this.extended_fields_titles[field_obj.parent_key], out_obj)

    }
  }

  fetchMasterEntries(ev, route, masters, field, section) {
    this.api.getMasters(route, ev).subscribe(res => {
      if (res && res['data'] && res['data'].list) {
        if (section && section.multiple) {
          let fieldValue = this.dynamic_form_group.value[section.fieldID];
          if (fieldValue && fieldValue.length) {
            for (let i = 0; i < fieldValue.length; i++) {
              let fieldValueItem = fieldValue[i][field.fieldID];
              if (fieldValueItem) {
                let match = masters[field.masterPropName].find(item => item.id === fieldValueItem);
                if (match) {
                  let list = res['data'].list;
                  if (Array.isArray(list)) {
                    let listMatch = list.find(item => item.id === fieldValueItem);
                    if (listMatch) {
                      masters[field.masterPropName] = cloneArray(list);
                    }
                    else {
                      list.push(match);
                      masters[field.masterPropName] = cloneArray(list);
                    }
                  }
                  else {
                    masters[field.masterPropName] = cloneArray(res['data'].list);
                  }
                }
                else {
                  masters[field.masterPropName] = cloneArray(res['data'].list);
                }
              }
              else {
                masters[field.masterPropName] = cloneArray(res['data'].list);
              }
            }
          }
          else {
            masters[field.masterPropName] = cloneArray(res['data'].list);
          }

        }
        else {
          masters[field.masterPropName] = cloneArray(res['data'].list);
        }
      }
    })
  }

  managePresentLocations(ev, masters, field, section, form_group) {
    console.log(ev)
    // if (ev && ev.type == 100) {
    //   // this.openLocationMap()
    // }
    // else {
    this.dialog.open(CvLocationComponent, {
      width: '40%',
      data: {},
      height: 'fit-content'
    }).afterClosed().subscribe(res => {
      if (res) {
        // this.current_selection = res;
        if (res && res.id) {
          this.loadCityListWithTimeStamp(masters, field, section, form_group);
          form_group.get(field.fieldID).patchValue(res.id);
          // this.registrationForm.controls.presentLocationId.patchValue(res.id)
        }
      }
    })
    // }

  }
  // openLocationMap() {
  //   this.matDialog.open(CvMapComponent, {
  //     width: '50%',
  //     data: {
  //       latitude: this.resumeBankForm.value.latitude,
  //       longitude: this.resumeBankForm.value.longitude
  //     }
  //   }).afterClosed().subscribe(res => {
  //     if (res) {
  //       this.resumeBankForm.controls.latitude.patchValue(res.latitude)
  //       this.resumeBankForm.controls.longitude.patchValue(res.longitude)
  //     }
  //   })
  // }

  loadCityListWithTimeStamp(masters, field, section, form_group) {
    this.profile_settings_srv.searchMasterWithTimestamp({
      "startPage": 1,
      "limit": 1000,
      "search": "",
      "lastTimeStamp": null
    }, 'get_city_list', 'cityList', 'id').subscribe(res => {
      if (res && res['data'] && res['data'].list) {
        console.log(res['data']['list'])
        masters[field.masterPropName] = res['data'].list.filter(data => data.type == 1)
        // this.timeBasedMaster.locationList = res['data'].list;
      }
    });
  }


  copyAddress(item) {
    try {
      this.form_control.patchValue(this.dynamic_form_group.value[item.copyFrom])
    }
    catch (Err) {

    }
  }

  suffixClicked(field, form_group, parentForm) {
    if (field && field.enableSuffix && form_group.get(field.fieldID) && form_group.get(field.fieldID).valid) {
      try {
        field.postObjEval = {};
        Object.keys(field.postObj).forEach(key => {
          try {
            field.postObjEval[key] = eval(field.postObj[key])
          }
          catch (err) {

          }
        });
        this.api.suffixActionFunction(field.apiURL, field.postObjEval).subscribe(res => {
          if (res && res['status']) {
            this.notification.success(res['message'], 'Close', 5000);
            try {
              eval(field.suffixPostSaveSuccess)
            }
            catch (err) {

            }
          }
          else {
            try {
              eval(field.suffixPostSaveFail)
            }
            catch (err) {

            }
            this.notification.error(res['message'], 'Close', 5000);
          }
        })
      }
      catch (err) { }
    } else {
      this.notification.error('Invalid ' + field.label, 'Close', 5000)
    }

    console.log(field)
  }


}
